import { FC } from 'react';

import { IoIosInformationCircle } from 'react-icons/io';

import { useTheme } from 'styled-components';

import { IHelperTextProps } from './types';
import { Container } from './styles';
import { Typography } from '../Typograph';

export const HelperText: FC<IHelperTextProps> = ({
  children,
  isError,
  isDisabled,
  iconColor = 'neutral500',
  icon: Icon = IoIosInformationCircle,
}) => {
  const theme = useTheme();

  return (
    <Container>
      <Icon
        size={16}
        color={
          isDisabled ? theme.neutral600 : isError ? theme.red : theme[iconColor]
        }
      />

      <Typography.Paragraph
        size="x-small"
        color={isDisabled ? 'neutral600' : isError ? 'red' : 'neutral400'}
      >
        {children}
      </Typography.Paragraph>
    </Container>
  );
};
